import Axios from "../../configs/axios.config";

//DashBoard API's
export const birthdayList = () => Axios.get(`/dashboard/birthday-list`);
export const holidaysList = () => Axios.get(`/dashboard/holiday-list`);

export const createQuickLink = (data) => Axios.post("/quick-link", data);
export const updateQuickLink = (uuid, data) =>
  Axios.put(`/quick-link/${uuid}`, data);
export const listQuickLink = (data) =>
  Axios.get("/quick-link").then((res) => res.data.data);
export const deleteQuickLink = (uuid) => Axios.delete(`/quick-link/${uuid}`);
export const getDashboardDataList = () => Axios.get("/dashboard/data-list").then((response) => response.data.data);
export const getDashboardData = () => Axios.get("/dashboard").then((response) => response.data);

